
<template>
    <div class="questionWrapper" v-if="text!==''">
        <transition name="question"  enter-active-class="animated swing"
                    leave-active-class="animated shake">
            <div class="text" >“{{text}}”</div>
        </transition>
    </div>
</template>
<script>
    export default {
        name: "Question",
        components: {},
        props: {
            text: {
                type: String,
                default:''
            },

        },
        data() {
            return {};

        },
        methods: {

        }
    };
</script>
<style lang="less" scoped>
    .questionWrapper {
        .text{
            color: #999;
            font-size: .44rem;
            line-height: .6rem;
            word-break: break-all;
            text-align: right;
            letter-spacing: .05rem;
        }
    }
    .question-item {
        display: inline-block;
        margin-right: 10px;
    }

    .question-enter-active,
    .question-leave-active {
        transition: opacity 0.5s;
    }

    .question-enter,
    .question-leave-to {
        opacity: 0;
    }
</style>
